<template>
  <ViewForm is-add />
</template>
<script>
import ViewForm from './components/ViewForm.vue';
export default {
  name: 'BusinessStockDistributionPlanAdd',
  components: {
    ViewForm,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},

  mounted() {},
  methods: {},
};
</script>
